import axiosPrivate from "./axiosPrivate";

const getProspectosTNP = (...args) => {
    const [
        usuario_id, perfil_id, dni, nombre, edad_max, num_entidad_titular,
        num_entidad_conyuge, saldo_otras_entidades_max, saldo_caja_max,
        deuda_caja, monto_cuota, promedio_mora, afecta_boleta,
        consentimiento_datos, atraso_aval, buro_id, contactado_id,
        estado_id, contrato_condicion, razon_social_id, gestor_id,
        celular, rows_per_page, page
    ] = args;

    return axiosPrivate.post("getProspectosTNP", {
        usuario_id, perfil_id, dni, nombre, edad_max, num_entidad_titular,
        num_entidad_conyuge, saldo_otras_entidades_max, saldo_caja_max,
        deuda_caja, monto_cuota, promedio_mora, afecta_boleta,
        consentimiento_datos, atraso_aval, buro_id, contactado_id,
        estado_id, contrato_condicion, razon_social_id, gestor_id,
        celular, rows_per_page, page
    }).then(response => response.data);
};

const gestionarProspectoTNP = (prospecto_id, contactado_id, estado_id, usuario_id, credito_fallido_id) => {
    return axiosPrivate.post("gestionarProspectoTNP", {
        prospecto_id, contactado_id, estado_id, usuario_id, credito_fallido_id
    }).then(response => response.data);
};

const registrarGestorProspectoTNP = (prospecto_ids, gestores_id, usuario_id, perfil_id, zonal_id) => {
    return axiosPrivate.post("registrarGestorProspectoTNP", {
        prospecto_ids, gestores_id, usuario_id, perfil_id, zonal_id
    }).then(response => response.data);
};

export default {
    getProspectosTNP,
    gestionarProspectoTNP,
    registrarGestorProspectoTNP,
};
